<mat-form-field appearance="fill">
    <mat-label>{{label}}</mat-label>
    <input matInput [(ngModel)]="value" (keydown.enter)="emitChange" (keyup)="keyup()" (change)="emitChange" value='valueDefault' />
    <button mat-icon-button matSuffix (click)="clear()" *ngIf="this.value">
        <mat-icon>clear</mat-icon>
    </button>
</mat-form-field>
